// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_screen__GWeJk {
  overflow-y: auto;
  scroll-behavior: smooth;
  background: #fafafb;
  color: #374151;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  font-size: 16px; }
  .styles_screen__GWeJk h1, .styles_screen__GWeJk h2, .styles_screen__GWeJk h3, .styles_screen__GWeJk p, .styles_screen__GWeJk li, .styles_screen__GWeJk a, .styles_screen__GWeJk span, .styles_screen__GWeJk strong, .styles_screen__GWeJk button, .styles_screen__GWeJk div {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif; }
  .styles_screen__GWeJk p, .styles_screen__GWeJk li {
    font-size: inherit; }

.styles_header__eqpRE {
  position: sticky;
  top: 0;
  z-index: 50;
  height: 68px;
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 0 clamp(16px, 4vw, 40px);
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid #e5e7eb; }

.styles_brand__LuI0c {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  flex-shrink: 0; }

.styles_brandMark__JR8Xm {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
  display: flex;
  align-items: center;
  justify-content: center; }
  .styles_brandMark__JR8Xm svg {
    width: 150%;
    height: 150%; }

.styles_brandName__iFcRr {
  font-size: 19px;
  font-weight: 400;
  color: #1f2937;
  letter-spacing: -0.01em; }

.styles_nav__Z-Awq {
  display: none;
  align-items: center;
  gap: 4px;
  margin-left: auto; }
  @media (min-width: 832px) {
    .styles_nav__Z-Awq {
      display: flex; } }

.styles_navLink__X4X5n {
  padding: 7px 13px;
  border-radius: 999px;
  color: #6b7280;
  font-size: 15px;
  font-weight: 500;
  text-decoration: none;
  transition: color 150ms ease, background 150ms ease; }
  .styles_navLink__X4X5n:hover {
    color: #1f2937;
    background: rgba(99, 102, 241, 0.06); }

.styles_navLinkActive__M3Ivz {
  color: #6366f1;
  background: rgba(99, 102, 241, 0.1); }

.styles_actions__NGA5x {
  margin-left: auto; }
  @media (min-width: 832px) {
    .styles_actions__NGA5x {
      margin-left: 8px; } }

button.styles_primaryAction__aeeKW {
  padding: 8px 18px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(90deg, #6366f1, #8b5cf6);
  color: white;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.25);
  transition: transform 150ms ease, box-shadow 150ms ease; }
  button.styles_primaryAction__aeeKW p {
    color: white;
    font-size: 14px; }
  button.styles_primaryAction__aeeKW:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(99, 102, 241, 0.3); }

.styles_hero__i2uUy {
  position: relative;
  padding: clamp(40px, 8vw, 88px) clamp(20px, 5vw, 48px) clamp(32px, 6vw, 64px);
  background: radial-gradient(960px 320px at 10% -10%, rgba(99, 102, 241, 0.14), transparent 60%), radial-gradient(640px 288px at 90% 0%, rgba(139, 92, 246, 0.12), transparent 60%), white;
  border-bottom: 1px solid #e5e7eb; }

.styles_heroInner__xnXcX {
  max-width: 1152px;
  margin: 0 auto; }

.styles_eyebrow__g10Kc {
  display: inline-block;
  margin-bottom: 16px;
  padding: 5px 12px;
  border-radius: 999px;
  background: rgba(99, 102, 241, 0.1);
  color: #6366f1;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase; }

.styles_title__2Dqam {
  margin: 0;
  font-size: clamp(32px, 5vw, 56px);
  font-weight: 300;
  line-height: 1.12;
  letter-spacing: -0.02em;
  color: #1f2937; }

.styles_meta__shR86 {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 24px; }

.styles_metaItem__qCuHg {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  background: white;
  font-size: 14px;
  color: #1f2937; }

.styles_metaLabel__ewlm- {
  color: #6b7280; }

.styles_intro__5Y-hz {
  max-width: 736px;
  margin-top: 28px;
  font-size: 18px;
  line-height: 1.7;
  color: #374151; }
  .styles_intro__5Y-hz p {
    margin: 0 0 14px; }
    .styles_intro__5Y-hz p:last-child {
      margin-bottom: 0; }

.styles_body__n2PsV {
  max-width: 1152px;
  margin: 0 auto;
  padding: clamp(28px, 5vw, 56px) clamp(16px, 5vw, 48px) 80px;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 40px; }
  @media (min-width: 1024px) {
    .styles_body__n2PsV {
      grid-template-columns: 256px minmax(0, 1fr);
      gap: 56px; } }

.styles_toc__laFvq {
  display: none; }
  @media (min-width: 1024px) {
    .styles_toc__laFvq {
      display: block;
      position: sticky;
      top: calc(68px + 32px);
      align-self: start;
      max-height: calc(100vh - 68px - 64px);
      overflow-y: auto; } }

.styles_tocTitle__sdbHE {
  display: block;
  margin-bottom: 12px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #6b7280; }

.styles_tocList__aQZ1- {
  list-style: none;
  margin: 0;
  padding: 0;
  border-left: 1px solid #e5e7eb; }
  .styles_tocList__aQZ1- li {
    margin: 0; }

.styles_tocLink__64ikP {
  display: block;
  margin-left: -1px;
  padding: 6px 0 6px 16px;
  border-left: 2px solid transparent;
  color: #6b7280;
  font-size: 14px;
  line-height: 1.4;
  text-decoration: none;
  transition: color 150ms ease, border-color 150ms ease; }
  .styles_tocLink__64ikP:hover {
    color: #6366f1;
    border-left-color: #6366f1; }

.styles_tocAside__nXV0Y {
  margin-top: 32px;
  padding: 16px;
  border-radius: 14px;
  background: rgba(99, 102, 241, 0.06);
  font-size: 14px;
  line-height: 1.6;
  color: #374151; }
  .styles_tocAside__nXV0Y a {
    color: #6366f1;
    font-weight: 600;
    word-break: break-word; }

.styles_article__tdV0j {
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 0; }

.styles_section__axdek {
  scroll-margin-top: calc(68px + 24px);
  padding: clamp(22px, 3vw, 36px);
  border: 1px solid #e5e7eb;
  border-radius: 20px;
  background: white;
  box-shadow: 0 1px 2px rgba(17, 24, 39, 0.04); }

.styles_sectionHighlight__GKb0z {
  border-color: rgba(99, 102, 241, 0.35);
  background: linear-gradient(180deg, rgba(99, 102, 241, 0.05), white 60%); }

.styles_sectionTitle__zCtjj {
  margin: 0 0 16px;
  font-size: clamp(20px, 2.4vw, 24px);
  font-weight: 500;
  line-height: 1.3;
  letter-spacing: -0.01em;
  color: #1f2937; }

.styles_prose__WLXfz {
  font-size: 16px;
  line-height: 1.75;
  color: #374151; }
  .styles_prose__WLXfz p {
    margin: 0 0 14px; }
    .styles_prose__WLXfz p:last-child {
      margin-bottom: 0; }
  .styles_prose__WLXfz h3 {
    margin: 28px 0 8px;
    font-size: 17px;
    font-weight: 600;
    color: #1f2937; }
    .styles_prose__WLXfz h3:first-child {
      margin-top: 0; }
  .styles_prose__WLXfz ul,
  .styles_prose__WLXfz ol {
    margin: 0 0 14px;
    padding-left: 22px; }
    .styles_prose__WLXfz ul:last-child,
    .styles_prose__WLXfz ol:last-child {
      margin-bottom: 0; }
  .styles_prose__WLXfz li {
    margin: 5px 0;
    padding-left: 4px; }
  .styles_prose__WLXfz ul li::marker {
    color: #6366f1; }
  .styles_prose__WLXfz ol li::marker {
    color: #6366f1;
    font-weight: 600; }
  .styles_prose__WLXfz strong {
    color: #1f2937;
    font-weight: 600; }
  .styles_prose__WLXfz a {
    color: #6366f1;
    text-decoration: underline;
    text-decoration-color: rgba(99, 102, 241, 0.35);
    text-underline-offset: 0.2em;
    word-break: break-word; }
    .styles_prose__WLXfz a:hover {
      text-decoration-color: #6366f1; }
  .styles_prose__WLXfz code {
    padding: 2px 6px;
    border-radius: 6px;
    background: #80808012;
    font-size: 0.9em; }

.styles_footer__1Hw7m {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 28px clamp(20px, 5vw, 48px);
  border-top: 1px solid #e5e7eb;
  background: white;
  font-size: 14px;
  color: #6b7280; }

.styles_footerNav__wHd-A {
  display: flex;
  flex-wrap: wrap;
  gap: 20px; }
  .styles_footerNav__wHd-A a {
    color: #6b7280;
    text-decoration: none; }
    .styles_footerNav__wHd-A a:hover {
      color: #6366f1; }

.styles_callout__rx1uU {
  margin: 16px 0;
  padding: 14px 18px;
  border-radius: 14px;
  border: 1px solid;
  font-size: 15px;
  line-height: 1.65; }
  .styles_callout__rx1uU:last-child {
    margin-bottom: 0; }
  .styles_callout__rx1uU > div {
    font-size: inherit; }

.styles_calloutTitle__FxICD {
  display: block; }

.styles_callout_info__ZfySx {
  border-color: rgba(99, 102, 241, 0.25);
  background: rgba(99, 102, 241, 0.06); }

.styles_callout_warning__9WmcL {
  border-color: rgba(220, 38, 38, 0.25);
  background: rgba(220, 38, 38, 0.05); }
`, "",{"version":3,"sources":["webpack://./src/modules/shelter/components/LegalLayout/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAaA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAVY;EAWZ,uGAP+F;EAQ/F,eAAe,EAAA;EANjB;IASI,uGAX6F,EAAA;EAEjG;IAaI,kBAAkB,EAAA;;AAItB;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,YAxBkB;EAyBlB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iCAAiC;EACjC,oCAAoC;EACpC,2BAA2B;EAC3B,gCAhCY,EAAA;;AAmCd;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,cAAc,EAAA;;AAGhB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;EACrD,8CArDc;EAsDd,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAA;EARzB;IAUI,WAAW;IACX,YAAY,EAAA;;AAIhB;EACE,eAAe;EACf,gBAAgB;EAChB,cAhEW;EAiEX,uBAAuB,EAAA;;AAGzB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB,EAAA;EAEjB;IANF;MAOI,aAAa,EAAA,EAEhB;;AAED;EACE,iBAAiB;EACjB,oBAAoB;EACpB,cAhFa;EAiFb,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mDAAmD,EAAA;EAPrD;IAUI,cAzFS;IA0FT,oCA5FY,EAAA;;AAgGhB;EACE,cAjGc;EAkGd,mCAlGc,EAAA;;AAqGhB;EACE,iBAAiB,EAAA;EAEjB;IAHF;MAII,gBAAgB,EAAA,EAEnB;;AAED;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,oDAAoD;EACpD,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,+CAtHc;EAuHd,uDAAuD,EAAA;EAVzD;IAaI,YAAY;IACZ,eAAe,EAAA;EAdnB;IAkBI,2BAA2B;IAC3B,8CAhIY,EAAA;;AAoIhB;EACE,kBAAkB;EAClB,6EAA6E;EAC7E,yLAGO;EACP,gCAtIY,EAAA;;AAyId;EACE,iBAAiB;EACjB,cAAc,EAAA;;AAGhB;EACE,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,mCAxJc;EAyJd,cAzJc;EA0Jd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB,EAAA;;AAG3B;EACE,SAAS;EACT,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,cApKW,EAAA;;AAuKb;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB,EAAA;;AAGlB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAhLY;EAiLZ,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,cAvLW,EAAA;;AA0Lb;EACE,cAzLa,EAAA;;AA4Lf;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAlMY,EAAA;EA6Ld;IAQI,gBAAgB,EAAA;IARpB;MAUM,gBAAgB,EAAA;;AAKtB;EACE,iBAAiB;EACjB,cAAc;EACd,2DAA2D;EAC3D,aAAa;EACb,qCAAqC;EACrC,SAAS,EAAA;EAET;IARF;MASI,2CAA2C;MAC3C,SAAS,EAAA,EAEZ;;AAED;EACE,aAAa,EAAA;EAEb;IAHF;MAII,cAAc;MACd,gBAAgB;MAChB,sBAAmC;MACnC,iBAAiB;MACjB,qCAAkD;MAClD,gBAAgB,EAAA,EAEnB;;AAED;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cA7Oa,EAAA;;AAgPf;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,8BAnPY,EAAA;EA+Od;IAOI,SAAS,EAAA;;AAIb;EACE,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,kCAAkC;EAClC,cAhQa;EAiQb,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qDAAqD,EAAA;EATvD;IAYI,cA3QY;IA4QZ,0BA5QY,EAAA;;AAgRhB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,oCApRc;EAqRd,eAAe;EACf,gBAAgB;EAChB,cApRY,EAAA;EA6Qd;IAUI,cA1RY;IA2RZ,gBAAgB;IAChB,sBAAsB,EAAA;;AAI1B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY,EAAA;;AAGd;EACE,oCAAiD;EACjD,+BAA+B;EAC/B,yBArSY;EAsSZ,mBAAmB;EACnB,iBAAiB;EACjB,4CAA4C,EAAA;;AAG9C;EACE,sCAjTc;EAkTd,wEAAmE,EAAA;;AAGrE;EACE,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAzTW,EAAA;;AA4Tb;EACE,eAAe;EACf,iBAAiB;EACjB,cA9TY,EAAA;EA2Td;IAMI,gBAAgB,EAAA;IANpB;MAQM,gBAAgB,EAAA;EARtB;IAaI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cA5US,EAAA;IA4Tb;MAkBM,aAAa,EAAA;EAlBnB;;IAwBI,gBAAgB;IAChB,kBAAkB,EAAA;IAzBtB;;MA2BM,gBAAgB,EAAA;EA3BtB;IAgCI,aAAa;IACb,iBAAiB,EAAA;EAjCrB;IAqCI,cAnWY,EAAA;EA8ThB;IAyCI,cAvWY;IAwWZ,gBAAgB,EAAA;EA1CpB;IA8CI,cA1WS;IA2WT,gBAAgB,EAAA;EA/CpB;IAmDI,cAjXY;IAkXZ,0BAA0B;IAC1B,+CAnXY;IAoXZ,4BAA4B;IAC5B,sBAAsB,EAAA;IAvD1B;MAyDM,8BAvXU,EAAA;EA8ThB;IA8DI,gBAAgB;IAChB,kBAAkB;IAClB,qBCvXa;IDwXb,gBAAgB,EAAA;;AAIpB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,oCAAoC;EACpC,6BArYY;EAsYZ,iBAAiB;EACjB,eAAe;EACf,cAzYa,EAAA;;AA4Yf;EACE,aAAa;EACb,eAAe;EACf,SAAS,EAAA;EAHX;IAMI,cAlZW;IAmZX,qBAAqB,EAAA;IAPzB;MASM,cAzZU,EAAA;;AA8ZhB;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,iBAAiB,EAAA;EANnB;IAQI,gBAAgB,EAAA;EARpB;IAYI,kBAAkB,EAAA;;AAItB;EACE,cAAc,EAAA;;AAGhB;EACE,sCAnbc;EAobd,oCApbc,EAAA;;AAubhB;EACE,qCAA0B;EAC1B,mCAAwB,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n// Sizes are in px because the app's root font-size changes per breakpoint,\n// which would otherwise make rem-based type shrink on phones.\n$indigo: #6366f1;\n$violet: #8b5cf6;\n$ink: #1f2937;\n$body: #374151;\n$muted: #6b7280;\n$line: #e5e7eb;\n$header-height: 68px;\n$sans: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n\n.screen {\n  overflow-y: auto;\n  scroll-behavior: smooth;\n  background: #fafafb;\n  color: $body;\n  font-family: $sans;\n  font-size: 16px;\n\n  h1, h2, h3, p, li, a, span, strong, button, div {\n    font-family: $sans;\n  }\n\n  p, li {\n    font-size: inherit;\n  }\n}\n\n.header {\n  position: sticky;\n  top: 0;\n  z-index: 50;\n  height: $header-height;\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  padding: 0 clamp(16px, 4vw, 40px);\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(12px);\n  border-bottom: 1px solid $line;\n}\n\n.brand {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  text-decoration: none;\n  flex-shrink: 0;\n}\n\n.brandMark {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: linear-gradient(135deg, $indigo, $violet);\n  box-shadow: 0 4px 12px rgba($indigo, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  svg {\n    width: 150%;\n    height: 150%;\n  }\n}\n\n.brandName {\n  font-size: 19px;\n  font-weight: 400;\n  color: $ink;\n  letter-spacing: -0.01em;\n}\n\n.nav {\n  display: none;\n  align-items: center;\n  gap: 4px;\n  margin-left: auto;\n\n  @media (min-width: 832px) {\n    display: flex;\n  }\n}\n\n.navLink {\n  padding: 7px 13px;\n  border-radius: 999px;\n  color: $muted;\n  font-size: 15px;\n  font-weight: 500;\n  text-decoration: none;\n  transition: color 150ms ease, background 150ms ease;\n\n  &:hover {\n    color: $ink;\n    background: rgba($indigo, 0.06);\n  }\n}\n\n.navLinkActive {\n  color: $indigo;\n  background: rgba($indigo, 0.1);\n}\n\n.actions {\n  margin-left: auto;\n\n  @media (min-width: 832px) {\n    margin-left: 8px;\n  }\n}\n\nbutton.primaryAction {\n  padding: 8px 18px;\n  border: none;\n  border-radius: 12px;\n  background: linear-gradient(90deg, $indigo, $violet);\n  color: white;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba($indigo, 0.25);\n  transition: transform 150ms ease, box-shadow 150ms ease;\n\n  p {\n    color: white;\n    font-size: 14px;\n  }\n\n  &:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 6px 16px rgba($indigo, 0.3);\n  }\n}\n\n.hero {\n  position: relative;\n  padding: clamp(40px, 8vw, 88px) clamp(20px, 5vw, 48px) clamp(32px, 6vw, 64px);\n  background:\n    radial-gradient(960px 320px at 10% -10%, rgba($indigo, 0.14), transparent 60%),\n    radial-gradient(640px 288px at 90% 0%, rgba($violet, 0.12), transparent 60%),\n    white;\n  border-bottom: 1px solid $line;\n}\n\n.heroInner {\n  max-width: 1152px;\n  margin: 0 auto;\n}\n\n.eyebrow {\n  display: inline-block;\n  margin-bottom: 16px;\n  padding: 5px 12px;\n  border-radius: 999px;\n  background: rgba($indigo, 0.1);\n  color: $indigo;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.title {\n  margin: 0;\n  font-size: clamp(32px, 5vw, 56px);\n  font-weight: 300;\n  line-height: 1.12;\n  letter-spacing: -0.02em;\n  color: $ink;\n}\n\n.meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 24px;\n}\n\n.metaItem {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 14px;\n  border: 1px solid $line;\n  border-radius: 999px;\n  background: white;\n  font-size: 14px;\n  color: $ink;\n}\n\n.metaLabel {\n  color: $muted;\n}\n\n.intro {\n  max-width: 736px;\n  margin-top: 28px;\n  font-size: 18px;\n  line-height: 1.7;\n  color: $body;\n\n  p {\n    margin: 0 0 14px;\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n}\n\n.body {\n  max-width: 1152px;\n  margin: 0 auto;\n  padding: clamp(28px, 5vw, 56px) clamp(16px, 5vw, 48px) 80px;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 40px;\n\n  @media (min-width: 1024px) {\n    grid-template-columns: 256px minmax(0, 1fr);\n    gap: 56px;\n  }\n}\n\n.toc {\n  display: none;\n\n  @media (min-width: 1024px) {\n    display: block;\n    position: sticky;\n    top: calc(#{$header-height} + 32px);\n    align-self: start;\n    max-height: calc(100vh - #{$header-height} - 64px);\n    overflow-y: auto;\n  }\n}\n\n.tocTitle {\n  display: block;\n  margin-bottom: 12px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: $muted;\n}\n\n.tocList {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  border-left: 1px solid $line;\n\n  li {\n    margin: 0;\n  }\n}\n\n.tocLink {\n  display: block;\n  margin-left: -1px;\n  padding: 6px 0 6px 16px;\n  border-left: 2px solid transparent;\n  color: $muted;\n  font-size: 14px;\n  line-height: 1.4;\n  text-decoration: none;\n  transition: color 150ms ease, border-color 150ms ease;\n\n  &:hover {\n    color: $indigo;\n    border-left-color: $indigo;\n  }\n}\n\n.tocAside {\n  margin-top: 32px;\n  padding: 16px;\n  border-radius: 14px;\n  background: rgba($indigo, 0.06);\n  font-size: 14px;\n  line-height: 1.6;\n  color: $body;\n\n  a {\n    color: $indigo;\n    font-weight: 600;\n    word-break: break-word;\n  }\n}\n\n.article {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  min-width: 0;\n}\n\n.section {\n  scroll-margin-top: calc(#{$header-height} + 24px);\n  padding: clamp(22px, 3vw, 36px);\n  border: 1px solid $line;\n  border-radius: 20px;\n  background: white;\n  box-shadow: 0 1px 2px rgba(17, 24, 39, 0.04);\n}\n\n.sectionHighlight {\n  border-color: rgba($indigo, 0.35);\n  background: linear-gradient(180deg, rgba($indigo, 0.05), white 60%);\n}\n\n.sectionTitle {\n  margin: 0 0 16px;\n  font-size: clamp(20px, 2.4vw, 24px);\n  font-weight: 500;\n  line-height: 1.3;\n  letter-spacing: -0.01em;\n  color: $ink;\n}\n\n.prose {\n  font-size: 16px;\n  line-height: 1.75;\n  color: $body;\n\n  p {\n    margin: 0 0 14px;\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h3 {\n    margin: 28px 0 8px;\n    font-size: 17px;\n    font-weight: 600;\n    color: $ink;\n    &:first-child {\n      margin-top: 0;\n    }\n  }\n\n  ul,\n  ol {\n    margin: 0 0 14px;\n    padding-left: 22px;\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  li {\n    margin: 5px 0;\n    padding-left: 4px;\n  }\n\n  ul li::marker {\n    color: $indigo;\n  }\n\n  ol li::marker {\n    color: $indigo;\n    font-weight: 600;\n  }\n\n  strong {\n    color: $ink;\n    font-weight: 600;\n  }\n\n  a {\n    color: $indigo;\n    text-decoration: underline;\n    text-decoration-color: rgba($indigo, 0.35);\n    text-underline-offset: 0.2em;\n    word-break: break-word;\n    &:hover {\n      text-decoration-color: $indigo;\n    }\n  }\n\n  code {\n    padding: 2px 6px;\n    border-radius: 6px;\n    background: $grey7;\n    font-size: 0.9em;\n  }\n}\n\n.footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 28px clamp(20px, 5vw, 48px);\n  border-top: 1px solid $line;\n  background: white;\n  font-size: 14px;\n  color: $muted;\n}\n\n.footerNav {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n\n  a {\n    color: $muted;\n    text-decoration: none;\n    &:hover {\n      color: $indigo;\n    }\n  }\n}\n\n.callout {\n  margin: 16px 0;\n  padding: 14px 18px;\n  border-radius: 14px;\n  border: 1px solid;\n  font-size: 15px;\n  line-height: 1.65;\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  & > div {\n    font-size: inherit;\n  }\n}\n\n.calloutTitle {\n  display: block;\n}\n\n.callout_info {\n  border-color: rgba($indigo, 0.25);\n  background: rgba($indigo, 0.06);\n}\n\n.callout_warning {\n  border-color: rgba(#dc2626, 0.25);\n  background: rgba(#dc2626, 0.05);\n}\n","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen": `styles_screen__GWeJk`,
	"header": `styles_header__eqpRE`,
	"brand": `styles_brand__LuI0c`,
	"brandMark": `styles_brandMark__JR8Xm`,
	"brandName": `styles_brandName__iFcRr`,
	"nav": `styles_nav__Z-Awq`,
	"navLink": `styles_navLink__X4X5n`,
	"navLinkActive": `styles_navLinkActive__M3Ivz`,
	"actions": `styles_actions__NGA5x`,
	"primaryAction": `styles_primaryAction__aeeKW`,
	"hero": `styles_hero__i2uUy`,
	"heroInner": `styles_heroInner__xnXcX`,
	"eyebrow": `styles_eyebrow__g10Kc`,
	"title": `styles_title__2Dqam`,
	"meta": `styles_meta__shR86`,
	"metaItem": `styles_metaItem__qCuHg`,
	"metaLabel": `styles_metaLabel__ewlm-`,
	"intro": `styles_intro__5Y-hz`,
	"body": `styles_body__n2PsV`,
	"toc": `styles_toc__laFvq`,
	"tocTitle": `styles_tocTitle__sdbHE`,
	"tocList": `styles_tocList__aQZ1-`,
	"tocLink": `styles_tocLink__64ikP`,
	"tocAside": `styles_tocAside__nXV0Y`,
	"article": `styles_article__tdV0j`,
	"section": `styles_section__axdek`,
	"sectionHighlight": `styles_sectionHighlight__GKb0z`,
	"sectionTitle": `styles_sectionTitle__zCtjj`,
	"prose": `styles_prose__WLXfz`,
	"footer": `styles_footer__1Hw7m`,
	"footerNav": `styles_footerNav__wHd-A`,
	"callout": `styles_callout__rx1uU`,
	"calloutTitle": `styles_calloutTitle__FxICD`,
	"callout_info": `styles_callout_info__ZfySx`,
	"callout_warning": `styles_callout_warning__9WmcL`
};
export default ___CSS_LOADER_EXPORT___;
